class SideCart extends HTMLElement {
  constructor() {
    super();

    this.configVarsEvents(false);
    var cartForm = document.getElementById("SideCartForm");

    this.addEventListener(
      "click",
      function (event) {
        var isClickInside = cartForm.contains(event.target);
        var isClickIcon = this.openCartBtn.forEach((elem) => {
          elem.contains(event.target);
          console.log(isClickInside, isClickIcon, this.swiperClick);

          if (
            !isClickInside &&
            !isClickIcon &&
            (this.swiperClick == undefined || !this.swiperClick)
          ) {
            this.closeSideCart();
          }
        })
      }.bind(this)
    );
  }

  configVarsEvents(is_open) {
    this.sideCartContainer = document.getElementById("section-v2-sidecart");
    this.openCartBtn = document.querySelectorAll('[data-open="cart"]');
    this.closeCartBtn = document.querySelectorAll(".side-cart__close-button");
    this.closeCartBtn.forEach((button) =>
      button.addEventListener("click", this.closeSideCart.bind(this))
    );
    this.isOpen = is_open;

    var minusQuantity = document.querySelectorAll(
      ".side-cart-item__quantity-minus"
    );
    var plusQuantity = document.querySelectorAll(
      ".side-cart-item__quantity-plus"
    );

    minusQuantity.forEach((button) =>
      button.addEventListener("click", this.reduceQuantity.bind(this))
    );

    plusQuantity.forEach((button) =>
      button.addEventListener("click", this.addQuantity.bind(this))
    );

    this.initSwiper();

    this.initUpsell();

    const onClickOutside = (e) => {
      if (
        e.composedPath().includes(document.querySelector(".side-cart__header"))
      ) {
        if (this.isOpen) {
          this.closeSideCart();
        }
      }
    };

    console.log(this.openCartBtn);

    this.openCartBtn.forEach((button) => {
      button.addEventListener("click", this.openSideCart.bind(this));
    });

    window.addEventListener("click", onClickOutside.bind(this));
  }

  initSwiper() {
    if (document.querySelector(".swiper-upsell")) {
      this.swiper = new Swiper(".swiper-upsell", {
        pagination: {
          el: ".swiper-upsell .swiper-pagination",
          clickable: true,
        },
        spaceBetween: 5,
        breakpoints: {
          990: {},
        },
      });

      this.swiper.on(
        "touchStart",
        function () {
          this.swiperClick = true;
          console.log(this.swiperClick);
        }.bind(this)
      );

      this.swiper.on(
        "touchEnd",
        function () {
          setTimeout(
            function () {
              this.swiperClick = false;
              console.log(this.swiperClick);
            }.bind(this),
            500
          );
        }.bind(this)
      );
    }
  }

  initUpsell() {
    document
      .querySelectorAll(".sidecart-upsell__form .product-form__submit")
      .forEach((item) => {
        item.addEventListener("click", this.addUpsellCart.bind(this));
      });
  }

  addUpsellCart(event) {
    event.preventDefault();
    var form = event.target.closest(".sidecart-upsell__form");
    var id = form.querySelector('[name="id"]').value;
    this.updateQuantity(id, 1);
  }

  openSideCart(event) {
    if (event) {
      event.preventDefault();
    }
    this.isOpen = true;
    this.sideCartContainer.classList.add("side-cart--open");
    this.sideCartContainer.classList.add("side-cart--indexed");
    document.querySelector("body").classList.add("overflow-hidden");
  }

  closeSideCart() {
    if (this.isOpen) {
      this.isOpen = false;
      document.querySelector("body").classList.remove("overflow-hidden");
      this.sideCartContainer.classList.remove("side-cart--open");
    }
  }

  addQuantity(event) {
    event.preventDefault();
    var line_item = event.target.closest("[data-variant-id]");
    var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
    var variant_id = line_item.getAttribute("data-variant-id");
    var new_quantity = actual_quantity + 1;

    line_item.setAttribute("data-quantity", new_quantity);
    line_item.querySelector("span").innerHTML = new_quantity;

    this.updateQuantity(variant_id, new_quantity);
  }

  reduceQuantity(event) {
    event.preventDefault();
    var line_item = event.target.closest("[data-variant-id]");
    var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
    var variant_id = line_item.getAttribute("data-variant-id");
    var new_quantity = actual_quantity - 1;

    if (new_quantity == 0) {
      line_item.classList.add("hidden");
    }

    line_item.setAttribute("data-quantity", new_quantity);
    line_item.querySelector("span.text--small").innerHTML = new_quantity;

    this.updateQuantity(variant_id, new_quantity);
  }

  updateQuantity(line, quantity) {
    this.enableLoading();
    var url = routes.cart_update_url + ".js";

    const update_label = "updates[" + line + "]=" + quantity;

    const body = update_label;

    fetch(url, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body,
    })
      .then((response) => {
        console.dir(response);
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.dir(parsedState);
        this.refreshCart();
      })
      .catch((error) => {
        //ERROR
        alert(
          "Error : Quantity update has a problem. If you see this error please contact us.\n" +
          error
        );
      });
  }

  refreshCart() {
    fetch("/cart?view=json")
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          alert(
            "Error 002 : Refresh cart has a problem. If you see this error please contact us."
          );
        }
      })
      .then((response) => {
        document.querySelector(".side-cart__wrapper").innerHTML = response;

        this.configVarsEvents(true);

        setTimeout(this.disableLoading, 500);
        setCssVars();


        document.querySelectorAll("[data-header-cart-count]").forEach((el) => {
          var data_count = el
            .innerHTML.split(" ")[0];
          if (document.querySelectorAll(".cart-count-bubble span:first-child")) {
            document.querySelectorAll(
              ".cart-count-bubble span:first-child"
            ).forEach((elem) => {
              elem.innerHTML = data_count;
            })
          }
        })


        var data_count = document
          .querySelector("[data-header-cart-count]")
          .innerHTML.split(" ")[0];
        if (document.querySelector(".cart-count-bubble span:first-child")) {
          document.querySelector(
            ".cart-count-bubble span:first-child"
          ).innerHTML = data_count;
        }
        const colors = ["#F4FF7A", "#99FFFC", "#FF93FC", "#CB83FF"];
        var styleElem = document.head.appendChild(
          document.createElement("style")
        );

        var buttons_text = document.querySelectorAll(".side-cart__checkout");
        buttons_text.forEach((button) => {
          var color = colors[Math.floor(Math.random() * colors.length)];
          var id = randstr("button_");
          button.setAttribute("id", id);
          styleElem.innerHTML += `#${id}::after {background: ${color};}`;
        });

        if (
          !document
            .querySelector(".side-cart")
            .classList.contains("side-cart--open")
        ) {
          this.openSideCart();
        }
      })
      .catch((error) => {
        alert(
          "Error 001 : Refresh cart has a problem. If you see this error please contact us.\n" +
          error
        );
      });
  }

  enableLoading() {
    document.querySelector("#SideCartForm").classList.add("loading");
  }

  disableLoading() {
    document.querySelector("#SideCartForm").classList.remove("loading");
  }
}

customElements.define("side-cart", SideCart);
